module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      },
      "enter": function($event) {
        return _vm.refresh()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.model && _vm.model.scheduled && !_vm.model.started),
            expression: "model && model.scheduled && !model.started"
          }],
          on: {
            "click": function($event) {
              return _vm.rollback()
            }
          }
        }, [_vm._v("Отменить выполнение")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.model && _vm.model.resultCode === 'PROCESS'),
            expression: "model && model.resultCode === 'PROCESS'"
          }],
          on: {
            "click": function($event) {
              return _vm.rollback()
            }
          }
        }, [_vm._v("Прервать выполнение")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.refresh
          }
        }, [_vm._v("Обновить")])]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c(_vm.strategy.viewContentComp(_vm.model), {
    tag: "component"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7cc912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/ActionProp.vue
// module id = 957
// module chunks = 1